var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_4238",
    "data-name": "\\uADF8\\uB8F9 4238",
    transform: "translate(-443 -753)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_alert_error_outline_24px",
    "data-name": "icon/alert/error_outline_24px",
    transform: "translate(466 776) rotate(180)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Boundary",
    width: 22,
    height: 22,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Color",
    "data-name": " \\u21B3Color",
    d: "M8.991,18A9,9,0,1,1,18,9,9.006,9.006,0,0,1,8.991,18ZM9,1.8A7.2,7.2,0,1,0,16.2,9,7.208,7.208,0,0,0,9,1.8Zm.9,11.7H8.1V11.7H9.9v1.8Zm0-3.6H8.1V4.5H9.9V9.9Z",
    transform: "translate(2 2)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Boundary-2",
    "data-name": "Boundary",
    width: 24,
    height: 24,
    transform: "translate(443 753)",
    fill: "none"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfo);
export default __webpack_public_path__ + "static/media/iconInfo.3170f0deff9538644821ad9126663ed1.svg";
export { ForwardRef as ReactComponent };